import { render, staticRenderFns } from "./SectionVerticalTextParagpraphs.vue?vue&type=template&id=ad765cb0&scoped=true&"
import script from "./SectionVerticalTextParagpraphs.vue?vue&type=script&lang=js&"
export * from "./SectionVerticalTextParagpraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad765cb0",
  null
  
)

export default component.exports